import {
	 reAddressConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : {},
	list       : [],
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reAddressConstants.GetPaged.REQUEST:
		case reAddressConstants.GetPagedAll.REQUEST:
		case reAddressConstants.GetList.REQUEST:
		case reAddressConstants.GetPagedAudit.REQUEST:
		case reAddressConstants.Create.REQUEST:
		case reAddressConstants.Delete.REQUEST:
		case reAddressConstants.Restore.REQUEST:
		case reAddressConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reAddressConstants.GetPaged.FAILURE:
		case reAddressConstants.GetPagedAll.FAILURE:
		case reAddressConstants.GetList.FAILURE:
		case reAddressConstants.GetPagedAudit.FAILURE:
		case reAddressConstants.Create.FAILURE:
		case reAddressConstants.Delete.FAILURE:
		case reAddressConstants.Restore.FAILURE:
		case reAddressConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reAddressConstants.GetPaged.SUCCESS:
		case reAddressConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reAddressConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reAddressConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count
			}
		case reAddressConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reAddressConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reAddressConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reAddressConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reAddressConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : {},
				list       : [],
				countAudit : null,
				pagedAudit : null
			}
		default:
			return state
	}
}